'use client';

import { ErrorBoundaryFallback } from '@/components/errors/ErrorBoundaryFallback';
import { GlobalErrorProviders } from '@/components/providers/base';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  return (
    <html lang="en">
      <body className="bg-background text-foreground">
        <GlobalErrorProviders>
          <ErrorBoundaryFallback error={error} />
        </GlobalErrorProviders>
      </body>
    </html>
  );
}
